<div class=" margin-bottom">
  <span class="mat-subheader">
    <button class="back-button" mat-icon-button *ngIf="backButtonPath" [routerLink]="backButtonPath">
      <mat-icon aria-label="voltar">arrow_back</mat-icon>
    </button>
    <ng-content></ng-content>
  </span>
</div>
